import state from "./moduleBillingState.js";
import mutations from "./moduleBillingMutations.js";
import actions from "./moduleBillingActions.js";
import getters from "./moduleBillingGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
